import Clarity from "@microsoft/clarity";

const PROJECT_ID = "w4j9k8ls2l";
let initialized = false;

export function initClarity() {
  if (initialized) return;
  Clarity.init(PROJECT_ID);
  initialized = true;
}

export function identifyUser(userId: string, email?: string, displayName?: string) {
  if (!initialized) return;
  Clarity.identify(userId, undefined, undefined, email);
  if (displayName) Clarity.setTag("displayName", displayName);
}

export function event(name: string, data?: Record<string, string | number | boolean | undefined>) {
  if (!initialized) return;
  Clarity.event(name);
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) Clarity.setTag(key, String(value));
    });
  }
}
